import partner1 from "src/shared/assets/partners/partner1.png";
import partner2 from "src/shared/assets/partners/partner2.svg";
import partner3 from "src/shared/assets/partners/partner3.png";
import partner4 from "src/shared/assets/partners/partner4.png";
import partner5 from "src/shared/assets/partners/partner5.svg";
import partner6 from "src/shared/assets/partners/partner6.webp";
import partner7 from "src/shared/assets/partners/partner7.svg";
import partner8 from "src/shared/assets/partners/partner8.svg";
import partner9 from "src/shared/assets/partners/partner9.svg";
import partner10 from "src/shared/assets/partners/partner10.svg";
import partner11 from "src/shared/assets/partners/partner11.svg";
import partner12 from "src/shared/assets/partners/partner12.png";

// Real company names (verified against each logo file, cross-checked against
// Sven's LinkedIn profile banner, which shows the same 10 of these 12 logos
// together — SEO_GEO_CHANGELOG.md, "[Task 5]"). Previously these were all
// alt="Partner N", which gave crawlers and screen readers no way to know
// which companies these are — a real loss given this is direct social proof
// for decision-makers.
export const partnersMarqueeData = [
  {
    alt: "Ippen Digital",
    image: partner1,
  },
  {
    alt: "Zalando",
    image: partner2,
  },
  {
    alt: "Microsoft",
    image: partner3,
  },
  {
    alt: "Infineon",
    image: partner4,
  },
  {
    alt: "Ströer",
    image: partner5,
  },
  {
    alt: "testo",
    image: partner6,
  },
  {
    alt: "Merck",
    image: partner7,
  },
  {
    alt: "Schubert",
    image: partner8,
  },
  {
    alt: "DocGaid",
    image: partner9,
  },
  {
    alt: "Anyline",
    image: partner10,
  },
  {
    alt: "HUK-COBURG",
    image: partner11,
  },
  {
    alt: "nexenio",
    image: partner12,
  },
];
